import React from "react"
import { FaUpload } from "react-icons/fa"
import { useSelector } from "react-redux"

import { FileUploaderWrapper } from "components"
import classes from "./EditorUploader.module.scss"

const EditorUploader = (props) => {
  const { editor, imageCategory } = props

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const handleAddImage = urls => {
    editor
      .chain()
      .focus()
      .setImage({ src: urls[0] })
      .run()
  }

  return (
    <div className={classes["container"]}>
      <FileUploaderWrapper
        enableCrop
        accountId={accountId}
        imageCategory={imageCategory}
        onUploadComplete={handleAddImage}
        maxNumberOfUploads={1}
      >
        <button
          className={classes["button"]}
        >
          <FaUpload />
        </button>
      </FileUploaderWrapper>
    </div>
  )
}

export default EditorUploader